import type {SVGProps} from 'react';

export const BookmarkIcon = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg
            fill='currentColor'
            {...props}
            viewBox='0 0 24 24'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path d='M17 3H7C6.46957 3 5.96086 3.21071 5.58579 3.58579C5.21071 3.96086 5 4.46957 5 5V21L12 18L19 21V5C19 3.89 18.1 3 17 3Z' />
        </svg>
    );
};
